var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "Header" } }, [
    _c("div", { staticClass: "header_content content_1040" }, [
      _c(
        "div",
        { staticClass: "left" },
        [
          _c(
            "router-link",
            { staticClass: "logo", attrs: { to: { path: "/" }, tag: "div" } },
            [
              _c("img", {
                attrs: {
                  src: require("@/assets/logo/header_logo.png"),
                  alt: ""
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "list_link" }, [
            _c(
              "nav",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "link_item",
                    attrs: {
                      tag: "a",
                      to: { path: "/" },
                      "active-class": "active",
                      exact: ""
                    }
                  },
                  [_vm._v("首页")]
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "right" },
        [
          !_vm.isLogin
            ? _c(
                "div",
                { staticClass: "login_entrance" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: { path: "Login" }, tag: "span" } },
                    [_vm._v("登录")]
                  ),
                  _vm._v(" "),
                  _c("b", [_vm._v("|")]),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    { attrs: { to: { path: "Register" }, tag: "span" } },
                    [_vm._v("注册")]
                  )
                ],
                1
              )
            : _c(
                "div",
                {
                  staticClass: "user_info",
                  on: {
                    mouseover: function($event) {
                      return _vm.mouseOver("user")
                    },
                    mouseleave: function($event) {
                      return _vm.mouseLeave("user")
                    }
                  }
                },
                [
                  _c("img", {
                    staticClass: "photo",
                    attrs: {
                      src:
                        JSON.stringify(_vm.UserPhoto) == "{}"
                          ? _vm.default_avater
                          : _vm.UserPhoto.original[0].url,
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.HoverUser,
                          expression: "HoverUser"
                        }
                      ],
                      staticClass: "user_operation_list"
                    },
                    [
                      _c("ul", [
                        _c(
                          "li",
                          {
                            staticClass: "tc",
                            on: {
                              click: function($event) {
                                return _vm.SignOut()
                              }
                            }
                          },
                          [_vm._v("退出")]
                        )
                      ])
                    ]
                  )
                ]
              ),
          _vm._v(" "),
          _vm.isExport && _vm.isLogin
            ? _c(
                "router-link",
                {
                  staticClass: "bg_blue upload",
                  attrs: { tag: "div", to: { name: "Edit_document" } }
                },
                [_vm._v("上传文档")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "bg_blue app_download",
              on: {
                mouseover: function($event) {
                  return _vm.mouseOver("APP")
                },
                mouseleave: function($event) {
                  return _vm.mouseLeave("APP")
                }
              }
            },
            [
              _c("div", { staticClass: "text" }, [
                _c("span", [_vm._v("APP下载")]),
                _vm._v(" "),
                _c("i", { class: [_vm.HoverAPP ? "on" : "", "icon_arrow"] })
              ]),
              _vm._v(" "),
              _c("transition", { attrs: { name: "el-fade-in-linear" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.HoverAPP,
                        expression: "HoverAPP"
                      }
                    ],
                    staticClass: "QR-Code_part"
                  },
                  [
                    _c("div", { staticClass: "item app" }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/logo/app.jpg"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "title" }, [
                        _vm._v("全球专家1对1"),
                        _c("br"),
                        _vm._v("扫码获取服务")
                      ])
                    ])
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61dd7a3d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61dd7a3d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = null
// module chunks = 